/*
 *
 * QuestionnairesList constants
 *
 */

export const SLICE_NAME = 'questionnairesList';
